import * as Yup from "yup";

import { measureMethods as _measureMethods } from "./shippingRateSchema";

export const measureMethods = _measureMethods

export const validateRowSchema = Yup.object().shape({
    ruleId: Yup
        .string()
        .required("Required"),
    id: Yup
        .string()
        .oneOf(measureMethods.map(i => i.id))
        .required("Required"),
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required('Required'),
    areaId: Yup
        .string()
        .required('Required'),
    rows: Yup.array().of(validateRowSchema),
})

export const initialRowValues = {
    ruleId: "",
    id: "",
    name: ""
}

export const initialValues = {
    rateId: "",
    locationId: "",
    locationName: "",
    areaId: "",
    areaName: "",
    rows: []
}
